import React from "react";
import { useTutorOnboardingStore } from "src/store/tutorOnboardingStore";
import SubjectSelection from "src/components/ui/SubjectSelection";
import ScrollToTop from "src/components/ScrollToTop";

const TutorOnboardingStepOne: React.FC = () => {
  const { selectedSubjects, setSelectedSubjects } = useTutorOnboardingStore();

  return (
    <>
      <ScrollToTop />
    <SubjectSelection
      selectedSubjects={selectedSubjects}
      onSubjectsChange={setSelectedSubjects}
      showHeader={true}
      showSelectedCount={true}
    />
    </>
  );
};

export default TutorOnboardingStepOne;